<app-wizard-modal (stepChange)="onStepChange($event)"
                  (stepErrorsChange)="onStepErrosChange()"
                  [isLoading]="isLoading"
                  (cancel)="cancel()"
                  (submit)="createTicket()">
    <app-wizard-title>{{ 'admin.tickets.create-modal.title' | translate }}</app-wizard-title>
    <app-wizard-step [canContinue]="selectToolsForm?.valid || maintenanceToolsAtLine?.length > 0">
        <ng-template #title>{{ 'admin.tickets.create-modal.sections.scanTools' | translate }}</ng-template>
        <ng-template #content let-step="step">
            <div class="info-message" *ngIf="this.firstTool && !isTicketWithMaintenanceAtLine()"><i
                class="material-icons">warning</i> {{ getInfoMessage() }}
            </div>

            <form [formGroup]="selectToolsForm">
                <div class="step-content step-one">
                    <div class="row"
                         *ngIf="maintenanceToolsAtLine && maintenanceToolsAtLine.length > 0 else withScanningTemplate">
                        <app-tool-scan-tree
                            labelText="{{'admin.tickets.create-modal.maintenance.createTicketForMaintenanceAtLine'| translate}}"
                            [items]="maintenanceToolsAtLine">
                        </app-tool-scan-tree>
                    </div>
                </div>
            </form>

            <ng-template #withScanningTemplate>
                <ng-container *ngTemplateOutlet="withScanning; context: { step: step }"></ng-container>
            </ng-template>

        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canContinue]="canContinueStep1()">
        <ng-template #title>{{ 'admin.tickets.create-modal.sections.ticketDetails' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <form [formGroup]="operationsForm">
                <div class="row" *ngIf="toolReturn && toolReturn.reason">
                    <div class="col s12">
                        <app-textbox label="{{'admin.tickets.details-modal.panel.lineInfo' | translate}}"
                                     class="line-info"
                                     [value]="toolReturn?.reason">
                        </app-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col s10">
                        <app-textarea [formControl]="operationsForm.controls['description']"
                                   [showErrors]="showValidations"
                                   placeholder="{{'admin.tickets.create-modal.description-input.placeholder' | translate }}"
                                   label="{{'admin.tickets.create-modal.description-input.label' | translate}}">
                        </app-textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col s12">
                        <app-picklist
                            [source]="operationTypes"
                            [(target)]="operationsForm.value.operationTypes"
                            [formControl]="operationsForm.controls.operationTypes"
                            [showValidations]="showValidations"
                            sourceHeader="{{'admin.tickets.create-modal.operation-types-input.leftHeader' | translate}}"
                            targetHeader="{{'admin.tickets.create-modal.operation-types-input.rightHeader' | translate}}"
                            infoLabel="{{'admin.tickets.create-modal.alert.message' | translate}}">
                        </app-picklist>
                    </div>
                </div>
            </form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step *ngIf="toolsHaveMaintenancePlan()" [canContinue]="operationsWithRecurrencesForm.valid">
        <ng-template #title>{{ 'admin.tickets.create-modal.sections.ticketRecurrences' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <div *ngIf="isLoading" class="loading">
                <app-loading-spinner></app-loading-spinner>
            </div>
            <form *ngIf="!isLoading" [formGroup]="operationsWithRecurrencesForm">
                <div class="button-container">
                    <app-button (click)="openRevisionModal()">
                        {{ 'admin.tickets.create-modal.revisionInfo.modal-button' | translate }}
                    </app-button>
                </div>

                <app-activities-form [formControl]="operationsWithRecurrencesForm.controls['selectedRecurrencesItems']"
                                     [items]="selectedRecurrencesItems"
                                     [activities]="operationsWithRecurrences">
                </app-activities-form>
            </form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canSave]="!isLoading" [saveDisabled]="hasSimilarTicketsInProgress()">
        <ng-template #title>
            <div [innerHTML]="'admin.tickets.create-modal.sections.ticketOverview' | translate">
            </div>
        </ng-template>
        <ng-template #content
                     let-step="step">
            <div *ngIf="isLoading" class="loading">
                <app-loading-spinner></app-loading-spinner>
            </div>
            <div *ngIf="!isLoading">
                <div [innerHTML]="computeOverviewStepDescription()" style="margin-bottom: 1rem"></div>
                <app-tree class="similarTickets"
                          emptyMessage="{{'admin.tickets.create-modal.overview.empty-message' | translate}}"
                          [parameters]="[{'value': 'date' , 'label':'admin.tickets.create-modal.overview.date' },
                                   {'value': 'tools', 'label':'admin.tickets.create-modal.overview.tools'},
                                   {'value': 'operations', 'label':'admin.tickets.create-modal.overview.operations'},
                                   {'value': 'description', 'label':'admin.tickets.create-modal.overview.description'}]"
                          [items]="computeSimilarTickets()">
                </app-tree>
                <app-ticket-overview *ngIf="toolsHaveMaintenancePlan()"
                                     [overviewItems]="overviewItems"
                                     [description]="this.toolReturn ? this.toolReturn.reason : '-'"
                                     (goTo)="goToPlan($event)">

                </app-ticket-overview>
            </div>
        </ng-template>
    </app-wizard-step>
</app-wizard-modal>

<app-revision-info-modal title="{{'admin.tickets.create-modal.revisionInfo.title' | translate}}">
</app-revision-info-modal>


<ng-template #withScanning let-currentStep="step">
    <div class="row">
        <app-tool-scan-tree
            labelText="{{'admin.tickets.create-modal.maintenance.scanTools' | translate}}"
            emptyMessage="{{'tree.toolSelect.emptyMessage' | translate}}"
            class="toolScanner"
            formControlName="selectedTools"
            [mode]="'scan'"
            [config]="config"
            [formControl]="selectToolsForm.controls['selectedTools']"
            [showErrors]="currentStep.nextTriggered && maintenanceToolsAtLine?.length === 0"
            [isScanListenerActive]="isOpen()"
            (toolSelect)="onToolScan($event)"
            [items]="selectedTools"
        ></app-tool-scan-tree>
    </div>
</ng-template>
